const r2 = (n) => Math.round(n * 100) / 100;

// Parts d'un dépôt d'après ses réservations (cle = "logement" ou "immeuble") : montant de chaque séjour, ramené au total du dépôt
export const partsDepuisResas = (resas, total, cle) => {
  if (!resas || resas.length < 2) return [];
  const poids = {};
  for (const r of resas) if (r[cle]) poids[r[cle]] = (poids[r[cle]] || 0) + Math.abs(r.montant || 0);
  const noms = Object.keys(poids);
  const somme = noms.reduce((s, n) => s + poids[n], 0);
  if (!noms.length || (noms.length > 1 && !somme)) return [];
  const parts = noms.map((nom) => ({ nom, montant: noms.length === 1 ? r2(total) : r2((total * poids[nom]) / somme) }));
  const ecart = r2(total - parts.reduce((s, p) => s + p.montant, 0));
  if (ecart) {
    const gros = parts.reduce((a, b) => (b.montant > a.montant ? b : a));
    gros.montant = r2(gros.montant + ecart);
  }
  return parts;
};

export const sansAccents = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
